module.exports = __webpack_public_path__ + "img/protection.9c7f8f32.svg";